"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.integrations")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.integrations", {
            url: "/integracoes",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-integrations" */ "./integrations.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.integrations")
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "conectionsViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Integrações"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Conecte os sistemas contábeis, financeiros, fiscais e de pessoal do escritório à Nucont."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.integration", {
            url: "/integracao?source&from",
            params: {
                source: { value: null, dynamic: true },
                from: { value: null, dynamic: true }
            },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-integrations" */ "./integrations.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.integrations")
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "integrationsViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4"
                }
            }
        })
        .state("nucont.accounting.integration.contaazul", {
            url: "/contaazul",
            params: { integration: "contazul" },
            views: {
                "integrationView@nucont.accounting.integration": {
                    component: "contaazulViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Conta Azul"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Conecte as empresas para buscar os dados financeiros do Conta Azul para a Nucont."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.integration.dominioideen", {
            // `aba` é o filtro rápido ativo. `reloadOnSearch: false` porque trocar de aba é trocar
            // de filtro, não de tela: sem isso o UI-Router reinstanciava o componente inteiro a
            // cada clique e a lista piscava.
            url: "/dominio-ideen?aba",
            reloadOnSearch: false,
            params: { integration: "dominio-ideen", aba: { value: null, squash: true } },
            views: {
                "integrationView@nucont.accounting.integration": {
                    component: "dominioIdeenViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Domínio Sistemas"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Conecte as empresas para buscar os dados contábeis do Domínio para a Nucont."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.integration.fortes", {
            url: "/fortes",
            params: { integration: "fortes" },
            views: {
                "integrationView@nucont.accounting.integration": {
                    component: "fortesViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Fortes"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Conecte as empresas para buscar os dados contábeis do Fortes para a Nucont."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.integration.contabit", {
            url: "/contabit",
            params: { integration: "contabit" },
            views: {
                "integrationView@nucont.accounting.integration": {
                    component: "contabitViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Contabit"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Conecte as empresas para buscar os dados contábeis do Contabit para a Nucont."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.integration.nibo", {
            url: "/nibo?companyName&code",
            params: {
                integration: "nibo",
                companyName: { dynamic: true, value: null },
                code: { dynamic: true, value: null }
            },
            views: {
                "integrationView@nucont.accounting.integration": {
                    component: "niboViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Nibo"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Conecte as empresas para buscar os dados financeiros do Nibo para a Nucont."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.integration.niboRedirect", {
            url: "/nibo-redirect?companyName&code",
            params: {
                companyName: { dynamic: true, value: null },
                code: { dynamic: true, value: null }
            },
            resolve: {
                redirect: [
                    "$stateParams",
                    "$state",
                    "$location",
                    ($stateParams, $state) => {
                        $state.go("nucont.accounting.integration.nibo", {
                            accountingId: $stateParams.accountingId,
                            source: "financeiro",
                            companyName: $stateParams.companyName,
                            code: $stateParams.code
                        });
                        return;
                    }
                ]
            }
        })
        .state("nucont.accounting.integration.omie", {
            url: "/omie",
            params: { integration: "omie" },
            views: {
                "integrationView@nucont.accounting.integration": {
                    component: "omieViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Omie"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Conecte as empresas para buscar os dados financeiros do Omie para a Nucont."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.integration.serpro", {
            url: "/serpro",
            params: { integration: "serpro" },
            views: {
                "integrationView@nucont.accounting.integration": {
                    component: "serproViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "PGDAS (Simples Nacional)"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Conecte as empresas para buscar as declarações do Simples Nacional para a Nucont."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.integration.eSocial", {
            url: "/eSocial",
            params: { integration: "eSocial" },
            views: {
                "integrationView@nucont.accounting.integration": {
                    component: "eSocialViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "eSocial"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Conecte as empresas para as quais você quer buscar os dados do eSocial para a Nucont."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.integration.certificate", {
            url: "/certificado",
            params: { integration: "certificate" },
            views: {
                "integrationView@nucont.accounting.integration": {
                    component: "certificateViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Certificado Digital"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Gerencie os certificados digitais usados nas integrações com o governo."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        });
}
